import { useApiPrivateRequest } from "../../../shared/hooks/useApi";

export const useSortLlmClients = () => {
  const {
    data: isSorted,
    call,
    isLoading,
    isFailed,
  } = useApiPrivateRequest<boolean>((_) => true);

  const sortLlmClients = async (
    llmName: string,
    orderedClientIds: string[],
  ) => {
    await call(`/admin/llm/${llmName}/clients/sort`, "PUT", undefined, {
      orderedClientIds,
    });
  };

  return {
    sortLlmClients,
    isSorted,
    isLoading,
    isFailed,
  };
};
